import * as React from "react";
import Component from "../../AbstractComponent";
import ChargeClassContainer from "../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import Searchbar from "../Searchbar/Searchbar";
import { DatePickerComponent } from "../DatePicker/DatePickerComponent";
import Formatter from "../../../Localization/Formatter";
import Select from "../../Partials/Material/Select";
import MenuItem from '@material-ui/core/MenuItem';
import TextField from "../../Partials/Material/TextField";
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { filterObjectsByOwner } from "./Utils/helpers";
export default class SalesPurchaseCharge extends Component {
  constructor(public props) {
    super(props);
  }

  public state: {
    isVatChanged: false,
  }

  public updateParentState = (callback?) => {
    if (typeof this.props.updateState === "function") {
      this.props.updateState.call(this, { ...this.props.state }, callback);
    }
  }

  public changeIsVatChanged = () => {
    this.setState({
      isVatChanged: true,
    })
  }

  public renderChargeType = (classId) => {
    return (
      <React.Fragment>
        {this.props.state.renderChargeType === TypeContainer.pickIdFromLabel("Settlement") && (
          <Select
            className="form-element full-size scroll-to-typeIdForCharge"
            error={this.getErrorFor("typeIdForCharge")}
            disabled={this.props.state.isDisabled}
            value={this.props.state.typeIdForCharge}
            onChange={this.props.changeTypeIdForCharge}
            htmlFor="type"
            label={this.trans("section/charge-field/type-label")}
            name="type"
            id="type"
          >
            {
              TypeContainer.getSettlementType().map((type, index) => {
                return (
                  <MenuItem key={index} value={type.id}>{`${Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                );
              })
            }
          </Select>
        )}

        {this.props.state.renderChargeType === TypeContainer.pickIdFromLabel("Payout_receivable") && (
          <Select
            className="form-element full-size scroll-to-typeIdForCharge"
            error={this.getErrorFor("typeIdForCharge")}
            disabled={this.props.state.isDisabled}
            value={this.props.state.typeIdForCharge}
            onChange={this.props.changeTypeIdForCharge}
            htmlFor="type"
            label={this.trans("section/charge-field/type-label")}
            name="type"
            id="type"
          >
            {
              TypeContainer.getPayoutReceivableType().map((type, index) => {
                return (
                  <MenuItem key={index} value={type.id}>{`${Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                );
              })
            }
          </Select>
        )}

        {this.props.state.renderChargeType === TypeContainer.pickIdFromLabel("Payout_payable") && (
          <Select
            className="form-element full-size scroll-to-typeIdForCharge"
            error={this.getErrorFor("typeIdForCharge")}
            disabled={this.props.state.isDisabled}
            value={this.props.state.typeIdForCharge}
            onChange={this.props.changeTypeIdForCharge}
            htmlFor="type"
            label={this.trans("section/charge-field/type-label")}
            name="type"
            id="type"
          >
            {
              TypeContainer.getPayoutPayableType().map((type, index) => {
                return (
                  <MenuItem key={index} value={type.id}>{`${Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                );
              })
            }
          </Select>
        )}

        {
          this.props.state.renderChargeType !== TypeContainer.pickIdFromLabel("Settlement") &&
          this.props.state.renderChargeType !== TypeContainer.pickIdFromLabel("Payout_receivable") &&
          this.props.state.renderChargeType !== TypeContainer.pickIdFromLabel("Payout_payable") && (
            <Select
              className="form-element full-size scroll-to-typeIdForCharge"
              error={this.getErrorFor("typeIdForCharge")}
              variant="standard"
              value={this.props.state.typeIdForCharge}
              onChange={this.props.changeTypeIdForCharge}
              htmlFor="type"
              label={this.trans("section/charge-field/type-label")}
              name="type"
              id="type"
              disabled={this.props.state.isDisabled}
            >
              {
                TypeContainer.getChargeTypes(Number(classId) == ChargeClassContainer.pickIdFromLabel("Payable") ? "payable" : "receivable")
                  .filter(chargeType => {
                    if ((TypeContainer.pickIdFromLabel("Savings_account_withdraw") === chargeType.id || TypeContainer.pickIdFromLabel("Savings_account_deposit") === chargeType.id) && (this.props.state.renderChargeType !== TypeContainer.pickIdFromLabel("Savings_account_withdraw") && this.props.state.renderChargeType !== TypeContainer.pickIdFromLabel("Savings_account_deposit"))) {
                      return false;
                    }

                    if ((TypeContainer.pickIdFromLabel("Stub_receivable") === chargeType.id || TypeContainer.pickIdFromLabel("Stub_payable") === chargeType.id) && (this.props.state.renderChargeType !== TypeContainer.pickIdFromLabel("Stub_receivable") && this.props.state.renderChargeType !== TypeContainer.pickIdFromLabel("Stub_payable"))) {
                      return false;
                    }

                    if (!!this.props.state.typeIdForCharge && chargeType.removed && (chargeType.id === this.props.state.typeIdForCharge)) {
                      return true;
                    }

                    if (chargeType.removed) {
                      return false;
                    }

                    return true;
                  })
                  .map((type, index) => {
                    return (
                      <MenuItem key={`chargeType-${index}`} value={type.id} disabled={(type.id === -1 || type.id === -2)}>{`${type.id === -1 || type.id === -2 ? type.label : Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                    );
                  })
              }
              {
                (TypeContainer.pickIdFromLabel("Credit_receivable") === this.props.state?.typeIdForCharge || TypeContainer.pickIdFromLabel("Credit_payable") === this.props.state?.typeIdForCharge) && <MenuItem key={`chargeType-${this.props.state?.typeIdForCharge}`} value={this.props.state?.typeIdForCharge}>{this.trans(`${TypeContainer.pickIdFromLabel("Credit_payable") === this.props.state?.typeIdForCharge ? "credit_payable" : "credit_receivable"}`)}</MenuItem>
              }
            </Select>
          )
        }
      </React.Fragment>
    );
  }

  public renderCharge = (classId, _labelText) => {
    if (!this.props.payment && this.props.coachType !== "registerIncomingInvoice") {
      return (
        <div>
          <TextField
            autoComplete="off"
            id="amountForCharge"
            className="form-element full-size scroll-to-amountForCharge"
            type="text"
            label={this.trans("section/charge-field/аmount-label")}
            value={this.props.state.amountForCharge}
            onChange={this.props.changeAmountForCharge}
            variant="standard"
            disabled={this.props.state.isDisabled}
            autoFocus={!!this.props.autoFocusAmount}
            error={!!this.getErrorFor("amountForCharge")}
            helperText={this.getErrorFor("amountForCharge")}
          />

          {this.props.selectedOwner && (
            <div className="search-bar-container" style={{/*margin: "-14px 0", position: "relative"*/}}>
              <Searchbar
                {...this.props}
                id="selectedEntityForCharge"
                className={"scroll-to-objectId"}
                floatingLabelText={`${this.trans("amount_related_to")} ${this.trans('field/optional')}`}
                allResults={true}
                objectField={true}
                onChange={this.props.selectEntityForCharge}
                onClear={this.props.clearEntityForCharge}
                selectedEntity={this.props.state.selectedEntityForCharge}
                searchParameter={"objectForChargeCoachSearch"}
                error={this.getErrorFor("objectId")}
                disabled={this.props.chargeType === "object"}
                showClickThroughLink={!this.props.dialogPresentation}
                searchText={this.props.state.selectedEntityForCharge ? `${this.props.state.selectedEntityForCharge.nameOfEntity}, ${this.props.state.selectedEntityForCharge.displayName}` : null}
                styleInModal={"pick-object-modal"}
                filterResults={(results) => filterObjectsByOwner(results, this.props.selectedOwner?.id)}
              />
            </div>
          )}
              {this.props.chargeType === "object" && (
                <div
                  className="info-text-blue"
                  // style={{
                  //   position: "absolute",
                  //   left: "460px",
                  //   top: "30px",
                  //   width: "fit-content"
                  // }}
                >
                  {this.trans("this_field_automatically_filled")}
                </div>
              )}
          {this.renderChargeType(classId)}

          <TextField
            autoComplete="off"
            id="descriptionForCharge"
            name="descriptionForCharge"
            className="form-element full-size scroll-to-descriptionForCharge"
            type="text"
            label={this.trans("section/charge-field/description-label")}
            value={this.props.state.descriptionForCharge}
            onChange={this.props.changeDescriptionForCharge}
            multiline={true}
            rowsMax={10}
            onKeyPress={() => {
              if (!this.props.state.descriptionForChargeIsManuallyChanged) {
                this.props.setState({ descriptionForChargeIsManuallyChanged: true });
              }
            }}
            disabled={this.props.state.isDisabled}
            variant="standard"
            error={!!this.getErrorFor("descriptionForCharge")}
            helperText={this.getErrorFor("descriptionForCharge")}
          />

          {
            (!this.props.state?.charge || (this.props.state?.charge && !this.props.state?.charge?.automaticallyCreated)) && (
              <DatePickerComponent
                {...this.props}
                id="dateOfPeriodForCharge"
                name="dateOfPeriodForCharge"
                className={"scroll-to-dateOfPeriodForCharge"}
                label={this.trans('service_provided_in_period')}
                initialDate={this.props.state.dateOfPeriodForCharge}
                onChange={date => this.props.selectDate(date, "dateOfPeriodForCharge")}
                clearButton={true}
                openTo={"month"}
                views={["year", "month"]}
                disableKeyboard={true}
                disabled={this.props.state.isDisabled}
                error={this.getErrorFor("dateOfPeriodForCharge")}
                margin="0 0 15px 0"
              />
            )
          }

          <DatePickerComponent
            {...this.props}
            id="firstDateForCharge"
            name="firstDateForCharge"
            className={"scroll-to-firstDateForCharge"}
            label={this.trans("include_charge_in_statement_for_period")}
            initialDate={this.props.state.firstDateForCharge}
            onChange={date => this.props.selectDate(date, "firstDateForCharge")}
            clearButton={true}
            openTo={"month"}
            views={["year", "month"]}
            disableKeyboard={true}
            disabled={this.props.state.isDisabled}
            error={this.getErrorFor("firstDateForCharge")}
            financialStatementId={this.props.state?.charge?.ownerFinancialStatementId}
          />

          {this.props.coachType !== "Receivable" &&
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                padding: "5px 0"
              }}
              onClick={this.props.handleChangeIsInvoice}
            >
              {
                this.props.state.isInvoice ?
                  <ExpandLess /> :
                  <ExpandMore />
              }
              <div>{this.trans("invoice")}</div>
            </div>
          }

          {this.props.coachType !== "Receivable" && this.props.state.isInvoice && this.renderInvoiceFields()}
        </div>
      );
    }

    // if (!this.props.payment && this.props.coachType === "registerIncomingInvoice") {
    //   return (
    //     <div>
    //       <DatePickerComponent
    //         {...this.props}
    //         className={"scroll-to-invoiceDateForCharge"}
    //         label={this.trans("section/charge-field/invoicedate-label")}
    //         initialDate={this.props.state.invoiceDateForCharge}
    //         onChange={date => this.props.selectDate(date, "invoiceDateForCharge")}
    //         disabled={this.props.state.isDisabled}
    //         clearButton={true}
    //         error={this.getErrorFor("invoiceDateForCharge")}
    //         margin={"14px 0"}
    //       />

    //       <TextField
    //         autoComplete="off"
    //         //id="invoiceNumberForCharge"
    //         className="form-element full-size scroll-to-invoiceNumberForCharge"
    //         type="text"
    //         label={`${this.trans("section/charge-field/invoicenumber-label")} ${this.trans('field/optional')}`}
    //         value={this.props.state.invoiceNumberForCharge}
    //         onChange={this.props.changeInvoiceNumberForCharge}
    //         variant="standard"
    //         disabled={this.props.state.isDisabled}
    //         error={!!this.getErrorFor("invoiceNumberForCharge") || !!this.getErrorFor("invoiceNumber")}
    //         helperText={this.getErrorFor("invoiceNumberForCharge") || this.getErrorFor("invoiceNumber")}
    //       />
    //       {(!!this.getErrorFor("invoiceNumberForCharge") || !!this.getErrorFor("invoiceNumber")) &&  (
    //         <div className="component-error-text">{this.getErrorFor("invoiceNumberForCharge") || this.getErrorFor("invoiceNumber")}</div>
    //       )}

    //       <TextField
    //         autoComplete="off"
    //         id="amountForCharge"
    //         className="form-element full-size scroll-to-amountForCharge"
    //         type="text"
    //         label={`${this.trans("section/charge-field/аmount-label")} (${this.trans("label-including-vat")})`}
    //         value={this.props.state.amountForCharge}
    //         onChange={this.props.changeAmountForCharge}
    //         variant="standard"
    //         disabled={this.props.state.isDisabled}
    //         autoFocus={!!this.props.autoFocusAmount}
    //         error={!!this.getErrorFor("amountForCharge")}
    //         helperText={this.getErrorFor("amountForCharge")}
    //       />

    //       <TextField
    //         autoComplete="off"
    //         className="form-element full-size scroll-to-vatPercentageForCharge"
    //         type="text"
    //         label={`${this.trans("label-vat")} %`}
    //         value={this.props.state.vatPercentageForCharge}
    //         onChange={this.props.changeVatPercentageForCharge}
    //         variant="standard"
    //         disabled={this.props.state.isDisabled}
    //         error={!!this.getErrorFor("vatPercentageForCharge")}
    //         helperText={this.getErrorFor("vatPercentageForCharge")}
    //       />

    //       <TextField
    //         autoComplete="off"
    //         //id="vatForCharge"
    //         className="form-element full-size scroll-to-vatForCharge"
    //         type="text"
    //         label={this.trans("section/invoice-field/vat-label")}
    //         value={this.props.state.vatForCharge}
    //         onChange={this.props.changeVatForCharge}
    //         variant="standard"
    //         disabled={this.props.state.isDisabled}
    //         error={!!this.getErrorFor("vatForCharge")}
    //         helperText={this.getErrorFor("vatForCharge")}
    //       />

    //       {this.props.selectedOwner && (
    //         <div className="search-bar-container" style={{margin: "-14px 0",position: "relative"}}>
    //           <Searchbar
    //             {...this.props}
    //             id="selectedEntityForCharge"
    //             className={"scroll-to-objectId"}
    //             floatingLabelText={`${this.trans("amount_related_to")} ${this.trans('field/optional')}`}
    //             allResults={true}
    //             objectField={true}
    //             onChange={this.props.selectEntityForCharge}
    //             onClear={this.props.clearEntityForCharge}
    //             selectedEntity={this.props.state.selectedEntityForCharge}
    //             searchParameter={"objectForChargeSearch"}
    //             error={this.getErrorFor("objectId")}
    //             disabled={this.props.chargeType === "object"}
    //             showClickThroughLink={!this.props.dialogPresentation}
    //             searchText={this.props.state.selectedEntityForCharge ? `${this.props.state.selectedEntityForCharge.nameOfEntity}, ${this.props.state.selectedEntityForCharge.displayName}` : null}
    //             styleInModal={"pick-object-modal"}
    //             filterResults={(results) => filterObjectsByOwner(results, this.props.selectedOwner?.id)}
    //           />
    //           {this.props.chargeType === "object" && (
    //             <div
    //               className="info-text-blue"
    //               style={{
    //                 position: "absolute",
    //                 left: "460px",
    //                 top: "30px",
    //                 width: "fit-content"
    //               }}
    //             >
    //               {this.trans("this_field_automatically_filled")}
    //             </div>
    //           )}
    //         </div>
    //       )}

    //       {this.renderChargeType(classId)}

    //       <TextField
    //         autoComplete="off"
    //         id="descriptionForCharge"
    //         name="descriptionForCharge"
    //         className="form-element full-size scroll-to-descriptionForCharge"
    //         type="text"
    //         label={this.trans("section/charge-field/description-label")}
    //         value={this.props.state.descriptionForCharge}
    //         onChange={this.props.changeDescriptionForCharge}
    //         multiline={true}
    //         rowsMax={10}
    //         onKeyPress={() => {
    //           if(!this.props.state.descriptionForChargeIsManuallyChanged) {
    //             this.props.setState({descriptionForChargeIsManuallyChanged: true});
    //           }
    //         }}
    //         disabled={this.props.state.isDisabled}
    //         variant="standard"
    //         error={!!this.getErrorFor("descriptionForCharge")}
    //         helperText={this.getErrorFor("descriptionForCharge")}
    //       />

    //       {
    //         (!this.props.state?.charge || (this.props.state?.charge && !this.props.state?.charge?.automaticallyCreated)) && (
    //           <DatePickerComponent
    //             {...this.props}
    //             id="dateOfPeriodForCharge"
    //             name="dateOfPeriodForCharge"
    //             className={"scroll-to-dateOfPeriodForCharge"}
    //             label={this.trans('service_provided_in_period')}
    //             initialDate={this.props.state.dateOfPeriodForCharge}
    //             onChange={date => this.props.selectDate(date, "dateOfPeriodForCharge")}
    //             clearButton={true}
    //             openTo={"month"}
    //             views={["year", "month"]}
    //             disableKeyboard={true}
    //             disabled={this.props.state.isDisabled}
    //             error={this.getErrorFor("dateOfPeriodForCharge")}
    //             margin="0 0 15px 0"
    //           />
    //         )
    //       }

    //       <DatePickerComponent
    //         {...this.props}
    //         id="firstDateForCharge"
    //         name="firstDateForCharge"
    //         className={"scroll-to-firstDateForCharge"}
    //         label={this.trans("include_charge_in_statement_for_period")}
    //         initialDate={this.props.state.firstDateForCharge}
    //         onChange={date => this.props.selectDate(date, "firstDateForCharge")}
    //         clearButton={true}
    //         openTo={"month"}
    //         views={["year", "month"]}
    //         disableKeyboard={true}
    //         disabled={this.props.state.isDisabled}
    //         error={this.getErrorFor("firstDateForCharge")}
    //         financialStatementId={this.props.state?.charge?.ownerFinancialStatementId}
    //       />
    //     </div>
    //   );
    // }
    if (this.props.payment && this.props.coachType !== "registerIncomingInvoice") {
      return (
        <div>
          <TextField
            autoComplete="off"
            id="amountForCharge"
            className="form-element full-size scroll-to-amountForCharge"
            type="text"
            label={this.trans("section/charge-field/аmount-label")}
            value={this.props.state.amountForCharge}
            onChange={this.props.changeAmountForCharge}
            variant="standard"
            disabled={this.props.state.isDisabled}
            autoFocus={!!this.props.autoFocusAmount}
            error={!!this.getErrorFor("amountForCharge")}
            helperText={this.getErrorFor("amountForCharge")}
          />
          {this.renderChargeType(classId)}
          <div className="search-bar-container" style={{/*margin: "-14px 0"*/}}>
            <Searchbar
              {...this.props}
              id="selectedEntityForCharge"
              className={"scroll-to-objectId"}
              floatingLabelText={this.props.coachType === "Receivable" ? this.trans("received_for") : this.trans("paid_for")}
              allResults={true}
              objectField={true}
              onChange={this.props.selectEntityForCharge}
              onClear={this.props.clearEntityForCharge}
              selectedEntity={this.props.state.selectedEntityForCharge}
              // searchParameter={"objectForChargeSearch"}
              error={this.getErrorFor("objectId")}
              disabled={this.props.chargeType === "object"}
              showClickThroughLink={!this.props.dialogPresentation}
              searchText={this.props.state.selectedEntityForCharge ? `${this.props.state.selectedEntityForCharge.nameOfEntity}, ${this.props.state.selectedEntityForCharge.displayName}` : null}
              styleInModal={"pick-object-modal"}
              filterResults={(results) => filterObjectsByOwner(results, this.props.selectedOwner?.id)}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              padding: "5px 0"
            }}
            onClick={this.props.handleShowMore}
          >
            {
              this.props.state.showMore ?
                <ExpandLess /> :
                <ExpandMore />
            }
            <div>{this.props.state.showMore ? this.trans("show_less") : this.trans("show_more")}</div>
          </div>

          {this.props.state.showMore && (
            <>
              <TextField
                autoComplete="off"
                id="descriptionForCharge"
                name="descriptionForCharge"
                className="form-element full-size scroll-to-descriptionForCharge"
                type="text"
                label={this.trans("section/charge-field/description-label")}
                value={this.props.state.descriptionForCharge}
                onChange={this.props.changeDescriptionForCharge}
                multiline={true}
                rowsMax={10}
                onKeyPress={() => {
                  if (!this.props.state.descriptionForChargeIsManuallyChanged) {
                    this.props.setState({ descriptionForChargeIsManuallyChanged: true });
                  }
                }}
                disabled={this.props.state.isDisabled}
                variant="standard"
                error={!!this.getErrorFor("descriptionForCharge")}
                helperText={this.getErrorFor("descriptionForCharge")}
              />

              <DatePickerComponent
                {...this.props}
                id="dateOfPeriodForCharge"
                name="dateOfPeriodForCharge"
                className={"scroll-to-dateOfPeriodForCharge"}
                label={this.trans('service_provided_in_period')}
                initialDate={this.props.state.dateOfPeriodForCharge}
                onChange={date => this.props.selectDate(date, "dateOfPeriodForCharge")}
                clearButton={true}
                openTo={"month"}
                views={["year", "month"]}
                disableKeyboard={true}
                disabled={this.props.state.isDisabled}
                error={this.getErrorFor("dateOfPeriodForCharge")}
                margin="0 0 15px 0"
              />

              <DatePickerComponent
                {...this.props}
                id="firstDateForCharge"
                name="firstDateForCharge"
                className={"scroll-to-firstDateForCharge"}
                label={this.trans("include_charge_in_statement_for_period")}
                initialDate={this.props.state.firstDateForCharge}
                onChange={date => this.props.selectDate(date, "firstDateForCharge")}
                clearButton={true}
                openTo={"month"}
                views={["year", "month"]}
                disableKeyboard={true}
                disabled={this.props.state.isDisabled}
                error={this.getErrorFor("firstDateForCharge")}
                financialStatementId={this.props.state?.charge?.ownerFinancialStatementId}
              />
            </>
          )}

          {this.props.coachType !== "Receivable" &&
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                padding: "5px 0"
              }}
              onClick={this.props.handleChangeIsInvoice}
            >
              {
                this.props.state.isInvoice ?
                  <ExpandLess /> :
                  <ExpandMore />
              }
              <div>{this.trans("invoice")}</div>
            </div>
          }
          {this.props.state.isInvoice && this.props.coachType !== "Receivable" && this.renderInvoiceFields()}
        </div>
      )
    }
  }

  public renderInvoiceFields = () => {
    return (
      <React.Fragment>
        <DatePickerComponent
          {...this.props}
          className={"scroll-to-invoiceDateForCharge"}
          label={this.trans("section/charge-field/invoicedate-label")}
          initialDate={this.props.state.invoiceDateForCharge}
          onChange={date => this.props.selectDate(date, "invoiceDateForCharge")}
          disabled={this.props.state.isDisabled}
          clearButton={true}
          error={this.getErrorFor("invoiceDateForCharge")}
        />

        {(this.props.payment || this.props.coachType !== "Receivable") && (
          <TextField
            autoComplete="off"
            //id="invoiceNumberForCharge"
            className="form-element full-size scroll-to-invoiceNumberForCharge"
            type="text"
            label={`${this.trans("section/charge-field/invoicenumber-label")} ${this.trans('field/optional')}`}
            value={this.props.state.invoiceNumberForCharge}
            onChange={this.props.changeInvoiceNumberForCharge}
            variant="standard"
            disabled={this.props.state.isDisabled}
            error={!!this.getErrorFor("invoiceNumberForCharge") || !!this.getErrorFor("invoiceNumber")}
            helperText={this.getErrorFor("invoiceNumberForCharge") || this.getErrorFor("invoiceNumber")}
          />
        )}
        {this.props.coachType !== "Receivable" && (!!this.getErrorFor("invoiceNumberForCharge") || !!this.getErrorFor("invoiceNumber")) && <div className="component-error-text">{this.getErrorFor("invoiceNumberForCharge") || this.getErrorFor("invoiceNumber")}</div>}

        {
          this.props.state.renderChargeType !== TypeContainer.pickIdFromLabel("Payout_receivable") &&
          this.props.state.renderChargeType !== TypeContainer.pickIdFromLabel("Payout_payable") && (
            <div>
              <TextField
                autoComplete="off"
                className="form-element full-size scroll-to-vatPercentageForCharge"
                type="text"
                label={`${this.trans("label-vat")} %`}
                value={this.props.state.vatPercentageForCharge}
                onChange={this.props.changeVatPercentageForCharge}
                variant="standard"
                disabled={this.props.state.isDisabled}
                error={!!this.getErrorFor("vatPercentageForCharge")}
                helperText={this.getErrorFor("vatPercentageForCharge")}
                InputLabelProps={{ shrink: this.state.isVatChanged }}
                onKeyPress={this.changeIsVatChanged}
              />

              <TextField
                autoComplete="off"
                //id="vatForCharge"
                className="form-element full-size scroll-to-vatForCharge"
                type="text"
                label={this.trans("section/invoice-field/vat-label")}
                value={this.props.state.vatForCharge}
                onChange={this.props.changeVatForCharge}
                variant="standard"
                disabled={this.props.state.isDisabled}
                error={!!this.getErrorFor("vatForCharge")}
                helperText={this.getErrorFor("vatForCharge")}
                InputLabelProps={{ shrink: this.state.isVatChanged }}
                onKeyPress={this.changeIsVatChanged}
              />
            </div>
          )
        }

        {
          (this.props.state.renderChargeType === TypeContainer.pickIdFromLabel("Payout_receivable") ||
            this.props.state.renderChargeType === TypeContainer.pickIdFromLabel("Payout_payable")) &&
          this.props.state?.charge?.collectiveVat?.map(vat => {
            return (
              <div>
                <TextField
                  autoComplete="off"
                  className="form-element full-size scroll-to-vatPercentageForCharge"
                  type="text"
                  label={this.trans("section/invoice-field/vatpercentage-label")}
                  value={vat.percentage}
                  // onChange={this.changeVatPercentageForCharge}
                  variant="standard"
                  disabled={this.props.state.isDisabled}
                  error={!!this.getErrorFor("vatPercentageForCharge")}
                  helperText={this.getErrorFor("vatPercentageForCharge")}
                />

                <TextField
                  autoComplete="off"
                  //id="vatForCharge"
                  className="form-element full-size scroll-to-vatForCharge"
                  type="text"
                  label={this.trans("section/invoice-field/vat-label")}
                  value={this.formatter.formatNumber(vat.totalVatAmount)}
                  // onChange={this.changeVatForCharge}
                  variant="standard"
                  disabled={this.props.state.isDisabled}
                  error={!!this.getErrorFor("vatForCharge")}
                  helperText={this.getErrorFor("vatForCharge")}
                />
              </div>
            );
          })
        }
      </React.Fragment>
    );
  }

  public render() {
    let labelText;

    if (this.props.pageName) {
      if (this.props.withoutTabs) {
        labelText = this.trans(`page/${this.props.pageName}-section/charge-field/object-label`)
      } else {
        labelText = this.trans(`page/${this.props.pageName}-section/charge-tab/newcharge-field/object-label`)
      }
    }

    return (
      <div style={{ position: "relative" }}>

        {this.renderCharge(this.props.state.chargeClassId, labelText)}

        {/* <PromptDialog
          {...this.props}
          title={this.trans("dialog/chargetype-title")}
          content={
            <ChargeTypeCreate
              {...this.props}
              onSaveType={this.props.addChargeType}
              onCancelType={this.props.closeChargeTypeCreateDialog}
              chargeTypeSelectField={Number(this.props.state.chargeClassId) == ChargeClassContainer.pickIdFromLabel("Payable") ? "Payable" : "Receivable"}
            />
          }
          openLeavePrompt={this.props.state.isCreateChargeTypePopupOpen}
          withoutDefaultDilaogButtons={true}
          onClose={this.props.closeChargeTypeCreateDialog}
        />

        <CoachNewCounterpartyDialog
          {...this.props}
          openCoachCreateNewCounterparty={this.props.state.openCoachCreateNewCounterparty}
          onCloseCounterpartyCoach={entity => {
            if(entity) {
              this.props.setState({
                openCoachCreateNewCounterparty: false            
              }, () => {this.props.selectCounterpartyForCharge(entity)})
            } else {
              this.props.setState({
                openCoachCreateNewCounterparty: false  
              })          
            }
          }}
        /> */}
      </div>
    );
  }
}
